
import BaseModel from '../../../helpers/basemodel'
import alert from '../../../helpers/alert'
import Api from '../../../helpers/api'

/**
 * Const
 *
 */
const api = new Api()



/**
 * State
 *
 */
const state = {
  ...BaseModel.state,

  permissions: {},
}


/**
 * Getters
 *
 */
const getters = {
  ...BaseModel.getters,

  data({ selectedObject }) {
    const data = { ...selectedObject }
    data.profile = {
      ...data.profile,
      get cost_daily_readable() {
        return this.cost_daily ? this.cost_daily.toLocaleString() : 0
      },
      get cost_monthly_readable() {
        return this.cost_monthly ? this.cost_monthly.toLocaleString() : 0
      },
      get cost_bpjs_kes_readable() {
        return this.cost_bpjs_kes ? this.cost_bpjs_kes.toLocaleString() : 0
      },
      get cost_bpjs_naker_readable() {
        return this.cost_bpjs_naker ? this.cost_bpjs_naker.toLocaleString() : 0
      },
    }

    return data
  },

  id({ selectedObject }) {
    return selectedObject.id
  },

  account({ selectedObject }) {
    return selectedObject.account || null
  },

  profile({ selectedObject }) {
    return selectedObject.profile || {}
  },

  permissions(state) { return state.permissions || {} },
}


/**
 * Actions
 *
 */
const actions = {
  ...BaseModel.actions,

  async fetchList({ commit, getters }) {
    commit(`loading_mode`, 1)

    return api.get(`/employee?` + getters.listOptions)
      .then(({ data, nrecord }) => {
        commit(`loading_mode`, 0)
        commit(`set_list`, data)
        commit(`set_nrecord`, nrecord)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async fetchOptions({ commit, getters }) {
    commit(`loading_mode`, 1)

    return api.get(`/employee?format=options`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)
        commit(`set_options`, data)
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async fetchData({ commit }, id) {
    if (!id) return commit(`clear_selected_object`)

    commit(`loading_mode`, 1)

    return api.get(`/employee/${id}`)
      .then(({ data }) => {
        commit(`loading_mode`, 0)

        const { id, account, ...profile } = data
        profile.id = id

        commit(`set_selected_object`, { id, profile, account })
      })
      .catch(err => {
        commit(`loading_mode`, 0)
        commit(`show_error`, err.message)
        return 0
      })
  },

  async refetchData({ dispatch }) {
    const id = state.selectedObject.id
    return dispatch(`fetchData`, id)
  },

  async fetchPermission({ commit }) {
    commit(`loading_mode`, 1)

    const id = state.selectedObject.id
    if (!id) return commit(`clear_permissions`)


    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)
      commit(`set_permissions`, result)
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      alert.danger(err.message)
      return 0
    }

    if (!id) return onerror({ message: `Gagal meload data` })

    return api.get(`/employee/${id}/permission`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async update({ commit, dispatch }, { id = '', data }) {
    commit(`loading_mode`, 1)

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)

      if (id) alert.success(`Data berhasil diupdate`)
      else alert.success(`Data berhasil ditambahkan`)

      return result.id
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      commit(`show_error`, err.message)
      return 0
    }

    return api.put(`/employee/${id}`, data)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async remove({ commit, dispatch }, id) {
    commit(`loading_mode`, 1)

    const onsuccess = async () => {
      commit(`loading_mode`, 0)
      alert.success(`Data berhasil dihapus`)
      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      commit(`show_error`, err.message)
      return 0
    }

    return api.delete(`/employee/${id}`)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async updateAccount({ state, commit, dispatch }, data) {
    commit(`loading_mode`, 1)

    const id = state.selectedObject.id

    const onsuccess = async () => {
      commit(`loading_mode`, 0)

      alert.success(`Data berhasil diupdate`)

      return 1
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      alert.danger(err.message)
      return 0
    }

    console.log(data)

    const params = {
      email: data.email,
      password: data.password,
    }

    if (!id) return onerror({ message: `Gagal mengupdate data `})

    return api.put(`/employee/${id}/account`, params)
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },

  async updatePermission({ commit }, rules) {
    commit(`loading_mode`, 1)

    const id = state.selectedObject.id
    if (!id) return false

    const onsuccess = async (result) => {
      commit(`loading_mode`, 0)
      alert.success(`Berhasil mengupdate data`)
    }

    const onerror = (err) => {
      commit(`loading_mode`, 0)
      alert.danger(err.message)
      return 0
    }

    if (!id) return onerror({ message: `Gagal meload data` })

    return api.put(`/employee/${id}/permission`, { rules })
      .then(r => onsuccess(r.data))
      .catch(onerror)
  },
}

/**
 * Mutations
 *
 */
const mutations = {
  ...BaseModel.mutations,

  set_permissions(state, perms) {
    state.permissions = perms
  },

  clear_permissions(state) {
    state.permissions = {}
  },
}

/**
 * Modules
 *
 */
import Presence from './presence'
import Sallary from './sallary'
import SallarySetting from './sallary-setting'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    Sallary,
    SallarySetting,
    Presence,
  }
}